import { generateKeyBetween, generateNKeysBetween } from 'fractional-indexing';

/**
 * Z-order and frame order use fractional indexes (sortable strings) instead of
 * array positions: two people reordering at the same time just write two keys,
 * whereas moving items inside a shared array can duplicate them.
 *
 * Concurrent inserts can produce identical keys. Sorting then falls back to the
 * id, and asking for a key "between" two identical keys returns one after them.
 */
export function orderBetween(a: string | null, b: string | null): string {
  if (a !== null && b !== null && a === b) return generateKeyBetween(a, null);
  return generateKeyBetween(a, b);
}

/** `n` ascending keys strictly between `a` and `b` (either may be null). */
export function ordersBetween(a: string | null, b: string | null, n: number): string[] {
  if (a !== null && b !== null && a === b) return generateNKeysBetween(a, null, n);
  return generateNKeysBetween(a, b, n);
}

/** Comparator for anything ordered by a fractional key, tie-broken by id. */
export function compareOrdered(
  a: { readonly id: string; readonly z: string },
  b: { readonly id: string; readonly z: string },
): number {
  if (a.z !== b.z) return a.z < b.z ? -1 : 1;
  if (a.id !== b.id) return a.id < b.id ? -1 : 1;
  return 0;
}

export function compareFrames(
  a: { readonly id: string; readonly order: string },
  b: { readonly id: string; readonly order: string },
): number {
  if (a.order !== b.order) return a.order < b.order ? -1 : 1;
  if (a.id !== b.id) return a.id < b.id ? -1 : 1;
  return 0;
}
